<template>
    <div class="container">
        <div style="overflow-y: auto">
            <div class="father">
                <p class="first">已使用金额:</p>
                <p class="second">{{ accumulated_amount }} 元</p>
            </div>

            <div class="father">
                <p class="first">隐私保护显示号码:</p>
                <div class="second" style="height: 100px; overflow-y: auto;display:flex;flex-wrap: wrap;">
                    <div class="text" v-for="(item, index) in virtual_number_pool" :key="index" style="width:30%;margin-right:20px">{{ item }}</div>
                </div>
            </div>

            <div>
                <el-row style="margin: 20px auto">
                    <el-col :span="24">
                        <el-card shadow="hover">
                            <div>
                                <h3>收费标准</h3>
                                <p>每个隐私号码月租费用{{ monthly_rent }}元/月，{{ univalence }}元/分钟，通话不足一分钟计费按一分钟计算</p>
                                <!-- <p>元/分钟，通话不足一分钟计费按一分钟计算</p> -->
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div>
            <div class="handle-box-search" v-if="activeName == 'tongHua'">
                <el-row class="head-search">
                    <el-col :span="10">
                        <span class="title">乘客电话:</span>
                        <el-input
                            style="width:200px"
                            v-model="search_data.consumer_phone"
                            class="handle-input mr10"
                            placeholder="请输入乘客电话"
                            @keyup.enter.native="searchVirtualNumberCallRecords"
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="14">
                        <span class="title">订单编号:</span>
                        <el-input
                            v-model="search_data.billno"
                            placeholder="请输入订单编号"
                            class="handle-input mr10"
                            style="width: 350px"
                            @keyup.enter.native="searchVirtualNumberCallRecords"
                        >
                        </el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="10">
                        <span class="title">司机电话:</span>
                        <el-input
                        style="width:200px"
                            v-model="search_data.driver_phone"
                            class="handle-input mr10"
                            placeholder="请输入司机电话"
                            @keyup.enter.native="searchVirtualNumberCallRecords"
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="14">
                        <span class="title">拨打电话时间:</span>

                        <el-date-picker
                            v-model="order_time_array"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>

                <el-row class="head-search"> </el-row>
            </div>
            <div v-if="activeName == 'tongHua'">
                <el-button type="primary" icon="el-icon-search" @click="searchVirtualNumberCallRecords">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button :icon="!progress_show ? 'el-icon-setting' : 'el-icon-loading'" @click="toExport" :disabled="progress_show">{{
                    progress_show ? '正在导出...' : '导出'
                }}</el-button>
                <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                    <el-progress :percentage="progress_data"></el-progress>
                    <i class="el-icon-loading"></i>
                    正在导出...
                </div>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick" type="card" style="margin-top: 20px">
                <el-tab-pane name="tongHua" class="to-searh" @click="handleClick">
                    <span slot="label" class="table-title">通话记录</span>
                </el-tab-pane>

                <el-tab-pane name="yueZu" class="to-searh" @click="handleClick">
                    <span slot="label" class="table-title">月租扣费</span>
                </el-tab-pane>
            </el-tabs>

            <!-- 表格 -->
            <el-table
                v-loading="tableLoading"
                v-if="activeName == 'tongHua'"
                :data="tableData"
                style="width: 100%"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="telX" label="通话号码" min-width="140"> </el-table-column>

                <el-table-column prop="billno" label="订单号" min-width="180"> </el-table-column>

                <el-table-column prop="telB" label="客户电话" min-width="140"> </el-table-column>

                <el-table-column prop="telA" label="司机电话" min-width="140"> </el-table-column>
                 <!-- 通话的呼叫方向。
                    A是司机，B是乘客
                    0：B呼叫A。
                    1：A呼叫B。 -->
                <el-table-column prop="direction" label="主叫方" min-width="80">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.direction == '0' ? '乘客' : '司机' }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="startTime" label="开始拨打时间" min-width="140"> </el-table-column>

                <el-table-column prop="finishTime" label="结束通话时间" min-width="140"> </el-table-column>

                <el-table-column prop="callDuration" label="通话时长" min-width="80"> </el-table-column>

                <el-table-column label="录音" width="320">
                    <template slot-scope="scope">
                        <div style="width: 100%">
                            <audio :src="scope.row.recording" id="audio" controls>您的浏览器不支持 audio 标签。</audio>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-else :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column prop="city_name" label="城市" min-width="140"> </el-table-column>
                <el-table-column prop="description" label="号码" min-width="140"> </el-table-column>

                <el-table-column prop="amount" label="扣费金额" min-width="180"> </el-table-column>

                <el-table-column prop="time_stamp" label="扣费时间" min-width="140"> </el-table-column>
                <el-table-column prop="type.name" label="扣费类型" min-width="140"> </el-table-column>
            </el-table>
            <!-- element ui 原生分页组件 -->
            <div class="pagination" v-if="result_data.count > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="search_data.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="result_data.count"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
let _this;

export default {
    components: {},
    data() {
        return {
            accumulated_amount: '',
            monthly_rent: '',
            univalence: '',
            virtual_number_pool: [],

            excelData: [],
            tableLoading: false,
            tableData: [],

            progress_data: 0,
            progress_show: false,
            result_data: {},
            search_url: '/virtual_number/virtualNumberCallRecords',
            activeName: 'tongHua',
            order_time_array: '', // 时间v-model绑定值
            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                consumer_phone: '',
                driver_phone: '',
                billno: '',
                fixed_array: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.searchVirtualNumberCallRecords(); //列表数据
        _this.getVirtualNumberCityConf(); //获取账户信息
    },
    methods: {
        // 导出
        toExport() {
            _this.search_data.page = 1;

            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/virtual_number/virtualNumberCallRecords', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.$route.path == '/privateNumber') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                telX: res.data[i].telX,
                                billno: res.data[i].billno,
                                telB: res.data[i].telB,
                                telA: res.data[i].telA,
                                direction: res.data[i].direction == '0' ? '乘客' : '司机',
                                startTime: res.data[i].startTime,
                                finishTime: res.data[i].finishTime,
                                callDuration: res.data[i].callDuration,
                                recording: res.data[i].recording
                            });
                        }

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;
                            _this.progress_data = Math.floor(((_this.search_data.page * _this.search_data.limit) / res.count) * 100);
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['通话号码', '订单号', '客户电话', '司机电话', '主叫方', '开始拨打时间', '结束通话时间', '通话时长', '录音'];
            const filterVal = ['telX', 'billno', 'telB', 'telA', 'direction', 'startTime', 'finishTime', 'callDuration', 'recording'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '隐私通话记录');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 时间change方法
        timeChange(val) {
            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between', ..._this.order_time_array]);
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
            console.log(tab.index, 'tab');

            _this.tableData = [];

            if (tab.index == '0') {
                _this.search_url = '/virtual_number/virtualNumberCallRecords';
                _this.search_data = {
                    page: 1,
                    limit: 10,

                    consumer_phone: '',
                    driver_phone: '',
                    billno: '',
                    fixed_array: ''
                };
            } else {
                _this.search_data = {
                    page: 1,
                    limit: 10
                };
                _this.search_url = '/virtual_number/virtualNumberRentMonthRecords';
            }
            _this.virtualNumberCallRecords();
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.virtualNumberCallRecords();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.virtualNumberCallRecords();
        },
        // 搜索
        searchVirtualNumberCallRecords() {
            _this.search_data.page = 1;
            _this.virtualNumberCallRecords();
        },
        // 列表数据初始化
        virtualNumberCallRecords() {
            _this.tableLoading = true;

            _this
                .$post(_this.search_url, _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableLoading = false;

                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {
                    _this.tableLoading = false;
                    _this.tableData = [];
                });
        },
        //获取账户信息
        getVirtualNumberCityConf() {
            _this.$post('/virtual_number/getVirtualNumberCityConf').then((res) => {
                _this.accumulated_amount = res.data.accumulated_amount;
                _this.virtual_number_pool = res.data.virtual_number_pool;
                _this.monthly_rent = res.data.monthly_rent;
                _this.univalence = res.data.univalence;
            });
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.father {
    display: flex;
    margin-top: 20px;
}
.first {
    text-align: right;
    width: 50%;
}
.second {
    width: 50%;
    margin-left: 10px;
}

.text {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #ff7606 !important;
}
</style>
